<template>
    <v-container
        fluid
        grid-list-xl
    >
        <v-layout
            justify-center
            wrap
        >
            <confirm-dialog
                ref="config-details"
                :show="dialogs.details.show"
                :width="1300"
                @close="closeDetails"
            >
                <div
                    slot="body"
                    class="diff-popup-body"
                >
                    <div class="left-column">
                        <div class="text-bold mb-3">
                            Action
                        </div>
                        <div>{{ dialogs.details.audit.action }}</div>
                        <div class="text-bold mt-5 mb-3">
                            Status
                        </div>
                        <div class="system-config-view__detail-value">
                            {{ dialogs.details.audit.status }}
                        </div>
                        <div class="text-bold mt-5 mb-3">
                            Created
                        </div>
                        <div class="system-config-view__detail-value">
                            {{ dialogs.details.audit.created | formatDate('DD MMMM YYYY HH:mm:ss') }}
                        </div>
                        <div class="text-bold mt-5 mb-3">
                            Event Type
                        </div>
                        <div class="system-config-view__detail-value">
                            {{ dialogs.details.audit.eventType }}
                        </div>
                        <div
                            v-if="dialogs.details.audit.user !== null"
                            class="text-bold mt-5 mb-3"
                        >
                            User
                        </div>
                        <div
                            v-if="dialogs.details.audit.user !== null"
                            class="system-config-view__detail-value copy-to-clip-form-group"
                        >
                            {{ dialogs.details.audit.username }} ({{ dialogs.details.audit.user }})
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <a
                                        class="action-btn"
                                        :href="`/dashboard/flows?userId-query=${dialogs.details.audit.user}`"
                                    >
                                        <v-icon
                                            class="mr-3 action-icon"
                                            v-on="on"
                                        >
                                            mdi-account-search
                                        </v-icon>
                                    </a>
                                </template>
                                <span class="text-white">View user details</span>
                            </v-tooltip>
                        </div>
                    </div>
                    <div class="right-column">
                        <div class="text-bold mb-3">
                            Changes
                        </div>
                        <div class="system-config-view__detail-value">
                            <table class="auditlogs-datachange-table" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th><span>Field</span></th>
                                        <th><span>Data Before</span></th>
                                        <th><span>Data After</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(change, index) in dialogs.details.audit.diff"
                                        :key="index"
                                    >
                                        <td>
                                            <span
                                                v-for="(step, idx) in change.path.split('.')"
                                                class="auditlogs-datachange-table-field"
                                                :key="index-idx"
                                            >
                                                {{ step }}
                                            </span>
                                            <br />
                                            <span
                                                v-if="change.type === 'CHANGE'"
                                                class="auditlogs-datachange-table-type change-updated"
                                            >
                                                Changed
                                            </span>
                                            <span
                                                v-if="change.type === 'CREATE'"
                                                class="auditlogs-datachange-table-type change-added"
                                            >
                                                Created
                                            </span>
                                            <span
                                                v-if="change.type === 'REMOVE'"
                                                class="auditlogs-datachange-table-type change-removed"
                                            >
                                                Deleted
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                v-if="change.changes.before"
                                                class="change-removed"
                                            >
                                                <json-viewer
                                                    :value="change.changes.before"
                                                    sort
                                                />
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                v-if="change.changes.after"
                                                class="change-added"
                                            >
                                                <json-viewer
                                                    :value="change.changes.after"
                                                    sort
                                                />
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div slot="action-buttons">
                    <v-btn
                        color="primary"
                        text
                        @click.stop="closeDetails"
                    >
                        Close
                    </v-btn>
                </div>
            </confirm-dialog>

            <confirm-dialog
                ref="datetime-picker"
                :show="dialogs.datepicker.show"
                :width="800"
                @confirm="confirmDatepicker"
                @close="closeDatepicker"
            >
                <div
                    slot="body"
                    class="diff-popup-body"
                >
                    <v-layout>
                        <v-flex md6>
                            <v-layout justify-center>
                                <v-date-picker
                                    v-model="tmp.dateFrom"
                                    :allowed-dates="pastDatesOnly"
                                    label="Date range"
                                    @input="dateFromChanged"
                                />
                            </v-layout>
                            <v-layout justify-center>
                                <v-btn
                                    color="primary"
                                    text
                                    @click.stop="() => tmp.dateFrom = null"
                                >
                                    Unset
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex md6>
                            <v-layout justify-center>
                                <v-date-picker
                                    v-model="tmp.dateTo"
                                    :allowed-dates="pastDatesOnly"
                                    label="Date range"
                                    @input="dateToChanged"
                                />
                            </v-layout>
                            <v-layout justify-center>
                                <v-btn
                                    color="primary"
                                    text
                                    @click.stop="() => tmp.dateTo = null"
                                >
                                    Unset
                                </v-btn>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </div>
            </confirm-dialog>

            <v-snackbar
                v-model="showCopiedToClipboard"
                location="bottom"
                class="mb-3"
                color="tertiary"
            >
                Copied to clipboard
            </v-snackbar>

            <v-flex
                md12
                class="filter-panel"
            >
                <v-layout>
                    <v-flex md6>
                        <v-text-field
                            v-model="filters.search"
                            prepend-icon="mdi-magnify"
                            label="Search"
                            @input="onChangeSearch"
                        />
                        <v-select
                            v-model="filters.eventType"
                            :items="enums.eventType"
                            label="Event Type"
                            @change="onChangeEventType"
                        />
                        <v-text-field
                            v-model="filters.flowId"
                            prepend-icon="mdi-sitemap"
                            label="FlowId"
                            @input="onChangeFlowId"
                        />
                    </v-flex>
                    <v-flex md6>
                        <v-text-field
                            v-model="filters.datePrettyPrint"
                            prepend-icon="mdi-calendar"
                            :readonly="true"
                            label="Date Range"
                            @click="openDatepicker()"
                        />
                        <v-text-field
                            v-model="filters.username"
                            item-text="username"
                            item-value="email"
                            label="User"
                            @change="onChangeUser"
                        />
                        <v-layout justify-end>
                            <v-btn
                                color="error"
                                text
                                @click.stop="resetSearch"
                            >
                                <v-icon>mdi-cancel</v-icon>
                                &nbsp;Reset
                            </v-btn>
                            <v-btn
                                color="tertiary"
                                text
                                @click.stop="reloadSearch"
                            >
                                <v-icon>mdi-reload</v-icon>
                                &nbsp;Reload
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click.stop="filterSearch"
                            >
                                <span
                                    v-if="totalPending() > 0"
                                    class="pending-filter-count"
                                >
                                    {{ totalPending() }}
                                </span>
                                Filter
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12>
                <material-card
                    :title="'Audit Logs'"
                    color="tertiary"
                >
                    <v-data-table
                        :headers="headers"
                        :items="auditLogs.data"
                        :loading-data="auditLogs.loading"
                        :must-sort="true"
                        :pagination.sync="sorting"
                        hide-actions
                        @update:sortBy="sortResults"
                    >
                        <template #headerCell="{ header }">
                            <span
                                class="subheading font-weight-bold text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template #items="{ item }">
                            <td>
                                <v-icon
                                    class="status-icon"
                                    :color="item.status === 'success' ? 'secondary' : 'error'"
                                >
                                    {{ item.status === 'success' ? 'mdi-check-circle': 'mdi-alert-circle' }}
                                </v-icon>
                            </td>
                            <td>{{ item.action }}</td>
                            <td>
                                <a
                                    v-if="item.user"
                                    href="javascript:void(0)"
                                    @click="filterByUser(item.user.username)"
                                >
                                    {{ item.user.username }}
                                </a>
                                <span
                                    v-else
                                >
                                    -
                                </span>
                            </td>
                            <td>{{ item.created | formatDate('DD MMMM YYYY HH:mm:ss') }}</td>
                            <td>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon
                                            class="mr-3 action-icon-int"
                                            v-on="on"
                                            @click="openDetails(item)"
                                        >
                                            mdi-eye
                                        </v-icon>
                                    </template>
                                    <span class="text-white">View</span>
                                </v-tooltip>
                            </td>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>

            <v-flex xs9>
                <v-layout class="modules-list__pagination">
                    <v-pagination
                        v-if="pagination.page > -5"
                        v-model="pagination.page"
                        :length="pagination.totalPages"
                        :total-visible="pagination.rowsPerPage"
                        justify-center
                        @input="onPageChange"
                    />
                </v-layout>
            </v-flex>
            <v-flex xs3>
                <v-layout
                    class="modules-list__pagination"
                    justify-end
                >
                    <v-btn
                        :color="enableCsvDownload ? 'secondary' : 'gray'"
                        text
                        :disabled="!enableCsvDownload"
                        @click.stop="downloadCSV"
                    >
                        <v-icon>mdi-file-excel</v-icon>
                        &nbsp;Download CSV
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import AuditLogRequests from '../../utils/requests/auditLog';
import ConfirmDialog from '@/components/common/ConfirmDialog.vue';

const emptyAudit = {
    action: '',
    status: '',
    user: '',
    ip: '',
    diff: '',
    eventType: '',
    username: '',
    created: '',
    details: ''
};

const queryParse = {
    page: parseInt,
    size: parseInt,
    sort: null,
    search: null,
    eventType: null,
    dateFrom: null,
    dateTo: null,
    username: null
};

const DEFAULT_PAGE_SIZE = 10;

export default {
    name: 'AuditLogsView',

    components: {
        ConfirmDialog
    },

    data() {
        return {
            dialogs: {
                details: {
                    show: false,
                    audit: emptyAudit
                },
                datepicker: {
                    show: false
                }
            },
            filters: {
                dates: [],
                search: '',
                flowId: '',
                eventType: null,
                dateFrom: null,
                dateTo: null,
                datePrettyPrint: '',
                username: null,
                ts: null
            },
            enableCsvDownload: false,
            showCopiedToClipboard: false,
            tmp: {
                dateFrom: null,
                dateTo: null
            },
            pendingFilters: {
                search: false,
                dateRange: false,
                eventType: false,
                user: false,
                flowId: false
            },
            tableOptions: {},
            auditLogs: {
                loading: false,
                changingPage: false,
                data: []
            },
            enums: {
                eventType: ['create', 'update', 'delete']
            },
            query: {
                manager: ''
            },
            sorting: {
                sortBy: 'created',
                descending: true,
                rowsPerPage: 10
            },
            pagination: {
                sortBy: 'created',
                descending: true,
                page: 1,
                rowsPerPage: 10,
                totalElements: 0,
                totalPages: 1
            },
            headers: [
                {
                    sortable: false,
                    text: '',
                    value: ''
                },
                {
                    sortable: false,
                    text: 'Action',
                    value: 'action'
                },
                {
                    sortable: false,
                    text: 'User',
                    value: 'user'
                },
                {
                    sortable: true,
                    text: 'Created',
                    value: 'created'
                },
                {
                    sortable: false,
                    text: '',
                    value: ''
                }
            ]
        };
    },

    watch: {
        'sorting.sortBy': {
            handler() {
                this.sortResults();
            },
            deep: true
        },
        'sorting.descending': {
            handler() {
                this.sortResults();
            },
            deep: true
        }

    },

    created() {
        this.initFilters();
        this.filters.ts = new Date(parseInt(this.$route.query.ts) || Date.now());
        this.getAuditLogs();
    },

    methods: {
        initFilters() {
            this.pagination.page = parseInt(this.$route.query.page) || 1;
            this.filters.search = this.$route.query.search || '';
            this.filters.flowId = this.$route.query.flowId || '';
            this.filters.eventType = this.$route.query.eventType || null;
            this.filters.dateFrom = this.$route.query.dateFrom || null;
            this.filters.dateTo = this.$route.query.dateTo || null;
            this.filters.datePrettyPrint = this.getDatePrettyPrint();
            this.filters.username = this.$route.query.username || null;
        },
        pastDatesOnly(date) {
            const today = new Date();
            today.setHours(23, 59, 59, 9999);
            return new Date(date) <= today;
        },
        dateFromChanged(date) {
            if (this.tmp.dateTo && this.tmp.dateTo < date) {
                this.tmp.dateTo = date;
            }
        },
        dateToChanged(date) {
            if (this.tmp.dateFrom && this.tmp.dateFrom > date) {
                this.tmp.dateFrom = date;
            }
        },
        totalPending() {
            return Object.values(this.pendingFilters).filter(v => v).length;
        },
        resetPendingFilters() {
            Object.keys(this.pendingFilters).forEach(key => {
                this.pendingFilters[key] = false;
            });
        },
        async getAuditLogs(query) {
            this.resetPendingFilters();
            const beQuery = this.paramsFromQuery();
            const finalQuery = { ...beQuery, ...query, ts: this.filters.ts.getTime() };
            this.auditLogs.loading = true;
            try {
                const { data, contentRange } = await AuditLogRequests.queryAuditLogs(finalQuery);
                this.initSorting(finalQuery);
                this.auditLogs.data = data;
                this.initPagination(contentRange);
            } finally {
                this.auditLogs.loading = false;
            }
        },
        filterSearch() {
            this.pagination.page = 1;
            const queryParams = this.getQueryParams({}, this);
            this.$router.push({ query: queryParams });
            this.getAuditLogs(queryParams);
        },
        reloadSearch() {
            this.filters.ts = new Date(Date.now());
            const queryParams = this.getQueryParams({}, this);
            this.$router.push({ query: queryParams });
            this.getAuditLogs({});
        },
        resetSearch() {
            this.filters.dates = [];
            this.filters.search = '';
            this.filters.eventType = null;
            this.filters.dateFrom = null;
            this.filters.dateTo = null;
            this.filters.datePrettyPrint = '';
            this.filters.username = null;
            this.sorting.sortBy = 'created';
            this.sorting.descending = true;
            this.sorting.rowsPerPage = 10;
            this.pagination.sortBy = 'created';
            this.pagination.descending = true;
            this.pagination.page = 1;
            this.pagination.rowsPerPage = 10;
            this.pagination.totalElements = 0;
            this.pagination.totalPages = 1;
            this.filters.ts = new Date(Date.now());
            this.$router.push({ query: {} });
            this.getAuditLogs({});
        },
        filterByUser(username) {
            this.pagination.page = 1;
            this.filters.username = username;
            const queryParams = this.getQueryParams({ username }, this);
            this.getAuditLogs(queryParams);
        },
        openDatepicker() {
            this.tmp.dateFrom = this.filters.dateFrom;
            this.tmp.dateTo = this.filters.dateTo;
            this.dialogs.datepicker.show = true;
        },
        onChangeDateRange() {
            this.pendingFilters.dateRange = true;
        },
        onChangeUser() {
            this.pendingFilters.user = true;
        },
        onChangeEventType() {
            this.pendingFilters.eventType = true;
        },
        onChangeSearch() {
            this.pendingFilters.search = true;
        },
        onChangeFlowId() {
            this.pendingFilters.flowId = true;
        },
        confirmDatepicker() {
            this.filters.dateFrom = this.tmp.dateFrom;
            this.filters.dateTo = this.tmp.dateTo;
            this.filters.datePrettyPrint = this.getDatePrettyPrint();
            this.onChangeDateRange();
            this.closeDatepicker();
        },
        getDatePrettyPrint() {
            if (this.filters.dateFrom === null && this.filters.dateTo === null) {
                return '';
            } else if (this.filters.dateFrom === null) {
                return `< ${this.filters.dateTo}`;
            } else if (this.filters.dateTo === null) {
                return `> ${this.filters.dateFrom}`;
            }
            return `${this.filters.dateFrom} - ${this.filters.dateTo}`;
        },
        closeDatepicker() {
            this.dialogs.datepicker.show = false;
        },
        paramsFromQuery() {
            const validParams = Object.keys(queryParse);
            return Object.keys(this.$route.query).reduce((acc, key) => {
                if (validParams.includes(key)) {
                    const queryParser = queryParse[key];
                    if (queryParser) {
                        acc[key] = queryParse[key](this.$route.query[key]);
                    } else {
                        acc[key] = this.$route.query[key];
                    }
                }
                return acc;
            }, {});
        },
        async downloadCSV() {
            if (!this.enableCsvDownload) {
                return;
            }
            const query = this.paramsFromQuery();
            query.page = 0;

            const link = document.createElement('a');
            link.style.display = 'none';
            link.setAttribute('download', 'audit_logs.csv');
            document.body.appendChild(link);

            try {
                const data = await AuditLogRequests.queryAuditLogsCSV(query);
                const blob = new Blob([data], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                link.href = url;
                link.click();
                window.URL.revokeObjectURL(url);
            } finally {
                document.body.removeChild(link);
            }
        },
        sortResults() {
            if (this.auditLogs.loading) {
                return;
            }
            if (this.auditLogs.changingPage) {
                return;
            }
            this.auditLogs.loading = true;
            this.onSortChange();
        },
        openDetails(item) {
            this.dialogs.details.show = true;
            this.dialogs.details.audit = {
                ...emptyAudit,
                action: item.action,
                status: item.status,
                diff: item.diff || [],
                user: item.user ? item.user.id : null,
                username: item.user ? item.user.username : '-',
                eventType: item.eventType,
                created: item.created,
                details: item.details ? item.details : '-'
            };
        },
        closeDetails() {
            this.dialogs.details.show = false;
            this.dialogs.details.item = emptyAudit;
        },
        copyToClipboard(value) {
            navigator.clipboard.writeText(value);
            this.showCopiedToClipboard = true;
        },
        initPagination(contentRange) {
            const [, end, total] = contentRange.split(/[-/]/);
            this.pagination.rowsPerPage = DEFAULT_PAGE_SIZE;
            this.pagination.totalElements = total;
            this.pagination.totalPages = Math.ceil(total / this.pagination.rowsPerPage);
            this.pagination.page = 1 + Math.floor(end / this.pagination.rowsPerPage);
            this.enableCsvDownload = total > 0;
        },
        initSorting(query) {
            if (!query.sort) {
                return;
            }
            if (query.sort.startsWith('-')) {
                this.sorting.descending = true;
                this.sorting.sortBy = query.sort.substring(1);
            } else {
                this.sorting.descending = false;
                this.sorting.sortBy = query.sort;
            }
        },
        onPageChange(page) {
            this.auditLogs.loading = true;
            const queryParams = this.getQueryParams({ page: page }, this);
            this.pagination.page = page;
            this.$router.push({ query: queryParams });
            this.getAuditLogs(queryParams, this);
            this.auditLogs.loading = false;
        },
        onSortChange() {
            this.onPageChange(1);
        },
        getQueryParams: (changes, that) => {
            const queryParams = {
                page: that.pagination.page || 1,
                flowId: that.filters.flowId || '',
                size: that.pagination.rowsPerPage || 10,
                sort: that.getSorting(),
                search: that.filters.search || '',
                eventType: that.filters.eventType,
                dateFrom: that.filters.dateFrom,
                dateTo: that.filters.dateTo,
                username: that.filters.username,
                ts: that.filters.ts || Date.now()
            };
            return { ...queryParams, ...changes };
        },
        getSorting() {
            if (!this.sorting.sortBy) {
                return '-created';
            }
            return this.sorting.descending ? `-${this.sorting.sortBy}` : this.sorting.sortBy;
        },
        log(v) {
            return '';
        }
    }
};
</script>

<style scoped>

</style>
